import * as React from 'react';
import { styled } from '@mui/system';

import colors from '../../../config/theme/colors';
import { field } from '../../../config/theme/componentTheme';

import { IDescription, ISection } from './definitions';
import { Container } from '../../../components/Grid';
import { toString } from 'ramda';
import { fm } from 'Components/FormatMessage';

export const SubHeader = styled('div')({
  fontWeight: 600,
  margin: '0 0 1rem 0',
});

export const StyledHistory = styled('div')({
  marginBottom: '0.5rem',
});

export const StyledHeader = styled('div')({
  marginTop: '2rem',
  marginBottom: '1rem',
  fontSize: '2.2rem',
  fontWeight: 600,
  color: colors.primary,
});

export const StyledRowContainerBar = styled(Container)({
  backgroundColor: colors.defaultBackground,
  width: 'auto',
  height: '5rem',
  margin: '0 -2.5rem',
  padding: '0 2.5rem',
});

export const StyledBarHeader = styled('div')({
  fontWeight: 600,
  marginBottom: '-0.3rem',
});

export const StyledSubQuestionArea = styled('div')({
  padding: '0 3rem',
  backgroundColor: colors.defaultBackground,
});

export const ReferenceText = styled('div')({
  color: colors.tertiaryText,
});

export const StyledDescriptionItems = ({
  description: { fields, section, marginLeft },
  key,
  path,
}: {
  description: IDescription;
  key: string;
  path: string;
}): React.JSX.Element => (
  <div style={{ marginLeft: `${marginLeft}rem` }} key={key}>
    {fields.map((item: string, index: number) => (
      <div key={section + field + index}>{fm(`${path}.${section}.${item}`)}</div>
    ))}
  </div>
);

export const StyledDescriptionField = ({
  sections,
  sectionPath,
  path,
  title,
  sectionTitle,
}: {
  sections: Array<ISection>;
  sectionPath: string;
  path: string;
  title?: string;
  sectionTitle?: string;
}): React.JSX.Element => (
  <div>
    {title && <div>{fm(title)}</div>}
    {sections.map((section: ISection) => (
      <div style={{ marginTop: `${section.marginTop}rem` }} key={section.section}>
        <SubHeader>{fm(`${sectionPath}.${section.section}${sectionTitle ? `.${sectionTitle}` : ''}`)}</SubHeader>
        {section.descriptions.map((d: IDescription) => (
          <StyledDescriptionItems description={d} key={toString(d.fields)} path={path} />
        ))}
      </div>
    ))}
  </div>
);
